import React from "react";

const hoc = props => <div>{props.children}</div>;

export default hoc;
